<!-- eslint-disable -->
<template lang="pug">
    component.box(
        :is="wrapper",
        :class=`[
            shadowClass,
            noPadding && 'box--no-padding'
        ]`
    )
      slot
</template>

<script>
    /*eslint-disable*/
    /**
     * Box are used for cards.
     */
    export default {
        name: "Box",
        status: "ready",
        release: "1.0.0",
        props: {
            /**
             * The html element name used for the wrapper.
             * `div, section`
             */
            wrapper: {
                type: String,
                default: "div",
                validator: value => {
                    return value.match(/(div|section)/)
                },
            },
            /**
             * The type of shadow.
             * `large, base`
             */
            shadow: {
                type: String,
                default: "disabled",
                validator: value => {
                    return value.match(/(disabled|large|base)/)
                },
            },
            /**
             * Property to remove padding from box
             */
            noPadding: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            shadowClass() {
                if (this.shadow !== "disabled") {
                    return "box--shadow-" + this.shadow
                }
                return ""
            },
        },
    }
</script>

<style lang="scss" scoped>
    .box {
        border-radius: $border-radius-6;
        background: $x-color-white;
        padding: $space-base;
        transition: 0.3s;
    }
    .box--shadow-large {
        box-shadow: $box-shadow-large;
    }
    .box--shadow-base {
        box-shadow: $box-shadow-base;
    }
    .box--no-padding {
        padding: 0;
    }
</style>
